export const PAYMENT_METHOD_TITLE_TEST_ID = 'PAYMENT_METHOD_TITLE';
export const PAYMENT_METHOD_RADIO_TEST_ID = 'PAYMENT_METHOD_RADIO';
export const PAYMENT_METHOD_DESCRIPTION_TEST_ID = 'PAYMENT_METHOD_DESCRIPTION';
export const PAYMENT_METHOD_ALT_LABEL_TEST_ID = 'PAYMENT_METHOD_ALT_LABEL';
